import { render, staticRenderFns } from "./GetAllEmails.vue?vue&type=template&id=ffdea316&"
import script from "./GetAllEmails.vue?vue&type=script&lang=js&"
export * from "./GetAllEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports